import {
    ActionTypes,
    ClientMessagesStatusEnum,
    doesWorkflowRejectCodeExist,
    getWorkflowRejectCodeMessage
} from '@tassat/common-definitions';
import { IFormValues } from '@tassat/forms/src/ClientMessagesForm/types';
import moment from 'moment';

import Worker from 'Lib/worker/PrimusWorker';

export const submitClientMessage = async (values: IFormValues, opts: {
    actionType: ActionTypes;
    editMessageId: string;
    setSubmitError: React.Dispatch<React.SetStateAction<string>>;
    onClose: () => void;
}) => {
    const {
        actionType,
        editMessageId,
        setSubmitError,
        onClose
    } = opts;

    const startDate = moment(values.StartAt)
        .valueOf();
    const endDate = moment(values.EndAt)
        .valueOf();
    const clientMsgType = typeof values.ClientMsgType === 'string' ? parseInt(values.ClientMsgType, 10) : values.ClientMsgType;
    const sendValues = {
        ClientMsgType: clientMsgType,
        StartAt: startDate,
        EndAt: endDate,
        Message: values.Message
    };

    try {
        let response = { data: undefined };
        if (actionType === ActionTypes.add) {
            response = await Worker.getInstance()
                .createClientMessage({ ...sendValues });
        } else if (actionType === ActionTypes.edit) {
            response = await Worker.getInstance()
                .updateClientMessage(editMessageId, {
                    ...sendValues,
                    Status: ClientMessagesStatusEnum.PENDING
                });
        }

        if (response.data && response.data.Status === 48) {
            onClose();
        } else if (response.data && response.data.Status === 49) {
            setSubmitError(`Could not ${actionType === ActionTypes.add ? 'add' : 'edit'} Message: ${response.data.Reason || 'Something went wrong'}`);
        } else if (response.data && doesWorkflowRejectCodeExist(response.data.Status)) {
            setSubmitError(`Could not ${actionType === ActionTypes.add ? 'add' : 'edit'} Message: ${getWorkflowRejectCodeMessage(response.data.Status)}`);
        }
    } catch (error) {
        setSubmitError('Something went wrong');
    }
};